"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotTypeE = exports.PurchaseTypeE = exports.LOT_API_URLS = void 0;
var LOT_API_URLS;
(function (LOT_API_URLS) {
    LOT_API_URLS["LOTS_BY_NFT"] = "/v2/lot/get-by-nft";
    LOT_API_URLS["LOTS_BY_NFTS"] = "/v2/lot/get-by-nfts";
    LOT_API_URLS["CHANGE_PRICE_REQUEST"] = "/v2/lot/change-price";
    LOT_API_URLS["AUCTION_WINNER"] = "/v2/auction/finalize";
    LOT_API_URLS["GET_ACTIVE_AUCTIONS_COUNT"] = "/v2/auction/get-my-active-auctions-count";
    LOT_API_URLS["GET_CURRENT_BIDS_BY_LOTS"] = "/v2/auction/get-current-bid-by-lots";
    LOT_API_URLS["GET_BIDS_BY_LOT"] = "/v2/auction/get-bids-by-lot";
    LOT_API_URLS["CREATE"] = "/v2/lot/create";
    LOT_API_URLS["FETCH_HOT_LOTS"] = "/v2/lot/get-hot";
})(LOT_API_URLS = exports.LOT_API_URLS || (exports.LOT_API_URLS = {}));
var PurchaseTypeE;
(function (PurchaseTypeE) {
    PurchaseTypeE[PurchaseTypeE["FIXED_PRICE"] = 1] = "FIXED_PRICE";
    PurchaseTypeE[PurchaseTypeE["TIMED_AUCTION"] = 2] = "TIMED_AUCTION";
})(PurchaseTypeE = exports.PurchaseTypeE || (exports.PurchaseTypeE = {}));
var LotTypeE;
(function (LotTypeE) {
    LotTypeE["UNKNOWN"] = "Unknown";
    LotTypeE["FIXED"] = "Fixed";
    LotTypeE["MULTIPLE"] = "Multiple";
    LotTypeE["AUCTION"] = "Auction";
    LotTypeE["FAUCTION"] = "FAuction";
    LotTypeE["OFFER"] = "Offer";
    LotTypeE["MULTIPLE_AUCTION"] = "MultipleAuction";
})(LotTypeE = exports.LotTypeE || (exports.LotTypeE = {}));
